<template>
  <v-combobox
    v-bind:value="value"
    :items="glossarySearchResults"
    :label="label"
    :search-input.sync="search"
    :rules="rules"
    ref="combobox"
    append-icon=""
    @change="checkInput(glossarySearchResults, $event)"
    @keydown="textupdate($event)"
  ></v-combobox>
</template>

<script>
import { AutoComplete } from "../glossaryUtils";
import { createGlossary } from "../api";
export default {
  props: ["value", "label", "rules"],
  components: {},
  watch: {
    search(value) {
      this.dirtyInput = true;
      if (!value) {
        this.dirtyInput = false;
      }
      this.$emit("updatetext", value);
      // if (value) {
      AutoComplete(value, this.label).then(results => {
        this.glossarySearchResults = results;

        if (results.length == 0) {
          this.glossarySearchResults = [];
        }
      });
      // }
    }
  },
  data() {
    return {
      dirtyInput: false,
      search: "",
      glossarySearchResults: []
    };
  },
  methods: {
    checkInput(items) {
      if (this.glossarySearchResults.length == 0 && this.dirtyInput) {
        let glossItem = {
          abbrevs: [],
          default: true,
          description: "",
          name: this.search,
          synonyms: []
        };
        createGlossary({ name: this.search });
      }
    },
    textupdate($event) {
      this.$emit("textchange");
    }
  }
};
</script>

<style></style>
